module.exports = __webpack_public_path__ + "static/assets/f1e1dc4b064ea22afaaef1af91a6140c.png";